import { Periodicity } from '@components/time-period-selector/PeriodsTypes';

type Configuration = {
  supportedPeriodicities: Periodicity[];
  disabledPeriodicityOptions: Periodicity[];
};

// Retailer Overview supportedPeriodicities is hardcoded to be Monthly + Weekly
export const retailerOverviewConfiguration: Configuration = {
  supportedPeriodicities: [Periodicity.Monthly, Periodicity.Weekly],
  disabledPeriodicityOptions: [],
};

export const categoryLeaderboardConfiguration: Configuration = {
  supportedPeriodicities: [
    Periodicity.Monthly,
    Periodicity.Weekly,
    Periodicity.RollingQuarter,
    Periodicity.CalendarQuarter,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
    Periodicity.YTD,
    Periodicity.MAT,
  ],
  disabledPeriodicityOptions: [],
};

export const opportunityReviewConfiguration: Configuration = {
  supportedPeriodicities: [
    Periodicity.Monthly,
    Periodicity.Weekly,
    Periodicity.YTD,
    Periodicity.MAT,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
    Periodicity.RollingQuarter,
    Periodicity.CalendarQuarter,
  ],
  disabledPeriodicityOptions: [
    Periodicity.YTD,
    Periodicity.MAT,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
    Periodicity.CalendarQuarter,
    Periodicity.RollingQuarter,
  ],
};

export const performanceAnalysisConfiguration: Configuration = {
  supportedPeriodicities: [
    Periodicity.Monthly,
    Periodicity.Weekly,
    Periodicity.RollingQuarter,
    Periodicity.CalendarQuarter,
    Periodicity.YTD,
    Periodicity.MAT,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
  ],
  disabledPeriodicityOptions: [
    Periodicity.YTD,
    Periodicity.MAT,
    Periodicity.RollingQuarter,
    Periodicity.CalendarQuarter,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
  ],
};

export const tradingAssistantConfiguration: Configuration = {
  supportedPeriodicities: [
    Periodicity.Monthly,
    Periodicity.Weekly,
    Periodicity.YTD,
    Periodicity.MAT,
    Periodicity.CustomMonths,
    Periodicity.CustomWeeks,
    Periodicity.CalendarQuarter,
    Periodicity.RollingQuarter,
  ],
  disabledPeriodicityOptions: [],
};
